import { Component, OnDestroy, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { RackeoLocaleService } from '../../services/locale.service';
import type { RackeoContent, RackeoMenuPromoData } from '../../services/locale.service';
import { RackeoCartService } from '../../services/cart.service';
import { URL } from '../../../../environments/environment';
import { RACKEO_SITE } from '../../rackeo-site';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
  readonly URL = URL;
  readonly site = RACKEO_SITE;
  activeMenu: string | undefined;
  menuPromo: RackeoMenuPromoData | undefined;

  isMobileMenuOpen = false;
  activeAccordion: string | undefined;

  private readonly sub = new Subscription();

  constructor(
    private readonly router: Router,
    public readonly cart: RackeoCartService,
    public readonly locale: RackeoLocaleService,
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) {
    this.sub.add(
      this.router.events
        .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
        .subscribe(() => {
          this.activeMenu = undefined;
          this.closeMobileMenu();
        })
    );
  }

  ngOnInit(): void {
    const snap = this.locale.getContentSnapshot();
    if (snap) this.applyMenuContent(snap);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.setBodyScroll(false);
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    if (!this.isMobileMenuOpen) {
      this.activeAccordion = undefined;
    }
    this.setBodyScroll(this.isMobileMenuOpen);
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
    this.activeAccordion = undefined;
    this.setBodyScroll(false);
  }

  toggleAccordion(name: string): void {
    this.activeAccordion = this.activeAccordion === name ? undefined : name;
  }

  private setBodyScroll(locked: boolean): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.overflow = locked ? 'hidden' : '';
    }
  }

  private applyMenuContent(c: RackeoContent): void {
    this.menuPromo = c.menuPromo;
  }

  openMenu(menuName: string): void {
    this.activeMenu = menuName;
  }

  closeMenu(): void {
    this.activeMenu = undefined;
  }
  /** Precio mensual plan SSD1 para el banner OFERTA VPS*/
  get vpsSsd1Monthly(): number | undefined {
    const mo = this.menuPromo?.vpsPlans?.[0]?.mo;
    return typeof mo === 'number' ? mo : undefined;
  }

  get domainComOfferPrice(): number | undefined {
    const p = this.menuPromo?.domainOfferPrice;
    return typeof p === 'number' ? p : undefined;
  }
}
